import React, { ReactElement } from 'react';
import { Box, Typography } from '@mui/material';

import { gray80 } from '../../../constants/colors';
import { regularSm } from '../../../constants/location';
import CustomTextfield from './CustomTextfield';

type Props = {
  labelText?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onBlur?: () => void;
  error?: boolean;
  helperText?: string;
  /** 拡張子（ドット付き、例: '.csv'）。空文字の場合は表示しない。 */
  extension?: string;
};

const styles = {
  row: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: '8px',
  },
  inputWrapper: {
    flex: 1,
  },
  extensionLabel: {
    ...regularSm,
    color: gray80,
    paddingBottom: '12px',
    whiteSpace: 'nowrap',
  },
};

/**
 * ファイル名入力フィールド（右隣に拡張子を表示）
 */
const FileNameWithExtensionField = ({
  labelText = 'ファイル名',
  value,
  onChange,
  onBlur,
  error,
  helperText,
  extension,
}: Props): ReactElement => {
  return (
    <Box sx={styles.row}>
      <Box sx={styles.inputWrapper}>
        <CustomTextfield
          labelText={labelText}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          inputWidth="100%"
          height="56px"
          error={error}
          helperText={helperText}
        />
      </Box>
      {extension && <Typography sx={styles.extensionLabel}>{extension}</Typography>}
    </Box>
  );
};

export default FileNameWithExtensionField;
